import { IMockHandler } from '@/mock/mock.handler.interface';
import { okDeleted, okList, okSingle } from '@/mock/mock.response.util';
import { ALL_ACTIVITY_FIXTURES, FILE_FIXTURES, WATCHLIST_FIXTURES } from '@/mock/watchlist/watchlist.fixtures';
import { PARAMETER_SETTING_FIXTURES } from '@/mock/parameter-setting/parameter-setting.fixtures';

const ID_ROUTE = /\/watchlist\/([^/?]+)$/;

export const watchlistHandler: IMockHandler = {
    matches(req: any) {
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        return req.url.includes('/watchlist');
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── GET /watchlist/activity/all ──────────────────────────────────────
        if (method === 'GET' && url.includes('/watchlist/activity/all')) {
            return okList(ALL_ACTIVITY_FIXTURES);
        }

        // ── GET /watchlist/files ─────────────────────────────────────────────
        if (method === 'GET' && url.includes('/watchlist/files')) {
            return okList(FILE_FIXTURES);
        }

        // ── GET /watchlist/:id ────────────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = WATCHLIST_FIXTURES.find((u) => String(u.id) === idMatch[1]);
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET | POST /watchlist  (list / search) ───────────────────────────
        if (method === 'GET' && url.endsWith('/watchlist')) {
            const page = Number(req.params.get('page') ?? 0);
            const size = Number(req.params.get('size') ?? 10);
            return okList(WATCHLIST_FIXTURES, page, size);
        }
        throw new Error(`[WatchlistHandler] unhandled: ${method} ${url}`);
    }
};
